import React from 'react'
import {
  AvatarBullet,
  AvatarBulletWrapper,
  AvatarWrapper,
  StyledAvatar
} from './Avatar.styles'

interface AvatarProps {
  name: string
  image?: string
  size?: 'medium' | 'big' | 'xbig' | 'xxbig'
  bullet?: number
  onClick?: () => void
}

const Avatar = ({
  name,
  image,
  size = 'medium',
  bullet,
  onClick,
  ...rest
}: AvatarProps) => {
  let displayName = ''

  if (name) {
    const names = name.split(' ')
    displayName = names[0].charAt(0)

    if (names.length > 1 && size !== 'medium') {
      displayName += names[1].charAt(0)
    }

    if (names.length === 1 && size !== 'medium') {
      displayName += names[0].charAt(1)
    }
  }

  return (
    <AvatarWrapper onClick={onClick}>
      <StyledAvatar data-testid="avatar" image={image} size={size} {...rest}>
        {image ? '' : displayName}
      </StyledAvatar>
      {bullet && (
        <AvatarBulletWrapper data-testid="bullet">
          <AvatarBullet>{bullet}</AvatarBullet>
        </AvatarBulletWrapper>
      )}
    </AvatarWrapper>
  )
}

export default Avatar
